import React, { useState } from 'react';

import { Modal } from 'antd';

import { RemonteControlPanel } from './RemoteControlPanel';
import { IShipment } from '../../../../features/shipments/models/shipment';
import PillButton from '@/components/PillButton';

interface Props {
  shipment?: IShipment;
  onCleanupComplete?: () => void;
}

const RemoteControl = ({ shipment, onCleanupComplete }: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <>
      <PillButton
        onClick={() => {
          setIsOpen(true);
        }}
        data-testid="remote-control-button"
      >
        Remote control
      </PillButton>
      <Modal
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        footer={null}
        width="61.25rem"
        destroyOnClose
      >
        <RemonteControlPanel
          isOpen={isOpen}
          shipment={shipment}
          onCleanupComplete={onCleanupComplete}
        />
      </Modal>
    </>
  );
};
export default RemoteControl;
